/**
 * Versión y fecha del paquete legal (privacidad, cookies, términos, consentimiento).
 * Debe coincidir con docs/politicas/*.md y consentimiento-datos.md tras cada revisión legal.
 *
 * Patrón de producto (aviso en capas, alineado con buenas prácticas de autoridades de PD):
 * - Capa 1: banner / checkbox corto con enlaces a documentos completos.
 * - Capa 2: estas páginas en la app + markdown en repo como fuente de verdad.
 *
 * @see https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/individual-rights/the-right-to-be-informed/how-should-we-draft-our-privacy-information/
 * @see https://ico.org.uk/for-organisations/uk-gdpr-guidance-and-resources/lawful-basis/consent/what-is-valid-consent/ (consentimiento afirmativo, sin casillas pre-marcadas)
 */
export const LEGAL_SUITE_VERSION = '1.7';

/** Misma fecha que "Vigente desde" en docs/politicas (mostrar en UI legal y registro). */
export const LEGAL_SUITE_LAST_UPDATED_LABEL = '27 de mayo de 2026';

/**
 * Consentimiento **específico** para el asistente de IA (después del registro).
 * Es independiente del paquete legal `LEGAL_SUITE_*`: finalidad granular (IA + terceros),
 * alineado con buenas prácticas de consentimiento por finalidad (véase guía Termly / ICO).
 * Texto mostrado: `AIConsentModal`; persistencia: `consent_records.consent_type = 'ai_financial_assistant'`.
 * v1.1: copy alineado a Google Gemini (Edge) + PDF; revisar con legal.
 * v1.2: migración de subprocesador Google Gemini → OpenAI (chat, tips y PDF); revisar con legal.
 */
export const AI_ASSISTANT_CONSENT_VERSION = '1.2';
